module.exports = __webpack_public_path__ + "static/media/008-dribbble-black.ca3aeaf2.svg";